import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { operations } from '~/api'
import { ProtectedPage } from '~/src/components/templates'
import { useFavorites } from '~/src/hooks/useApi'
import { Favorites } from '../../organisms/Favorites'

type ApiParams = operations['getFavorites']['parameters']['query']
type ApiResponse = operations['getFavorites']['responses']['200']['content']['application/json']

const convert = (data: ApiResponse) =>
  data.items?.map((f) => ({
    ref: f.item?.refNo,
    name: f.item?.displayName,
    type: f.item?.stockType,
    favorites: f.count,
  }))

export const MyFavoritesList: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()
  const [params, setParams] = useState<ApiParams>()
  const { data } = useFavorites(params)

  return (
    <ProtectedPage pageTitle={t('favorites.my_favorites')}>
      {data && (
        <Favorites
          data={convert(data)}
          pagination={data.pagination!}
          onNextPage={(v) => {
            setParams({ ...params, offset: Number(v.page) + 1 })
          }}
          maxHeight={'auto'}
        />
      )}
    </ProtectedPage>
  )
}
